import {inject, Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable, of} from "rxjs";
import {AuthService} from "../auth/auth.service";
import {map} from "rxjs/operators";

@Injectable({
    providedIn: 'root'
})
export class RoleGuardService {
    readonly #authService: AuthService = inject(AuthService);

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
        return this.#authService.user$.pipe(
            map((user: any) => user
                ? user.roles.some((role: string) => route.data['roles'].includes(role))
                : of(false)),
        )
    }
}
